import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NewsDataService} from './news/news-data.service';
import {HttpClientModule} from '@angular/common/http';
import {StaticDataService} from './static/static-data.service';
import {MenuDataService} from './menu/menu-data.service';
import {VodDataRestService} from './vod/vod-data-rest.service';
import {SubscriptionDataService} from './subscription/subscription-data.service';
import { BtvDataRestService } from './btv/btv-data-rest.service';
import { Configuration, ApiModule, ClientServicesService } from './360-client-api';
import { AuthenticationService, OperationalService } from './a2srv-client-api';
import { CustomerServicesService, SubscriberServicesService, ProductServicesService } from './crm-client-api';
import { BtvClientServicesService } from './cms-btv-client-api';
import { VodClientServicesService } from './cms-vod-client-api';
import { NotDataRestService } from './notification/not-data-rest.service';
import { NotificationCustomerServicesService, NotificationMessageServicesService } from './notification-api';
import { MetaService } from './meta/meta.service';
import { PodcastDataRestService } from './podcast/podcast-data-rest.service';
import { PodcastClientServicesService } from './podcast-client-api';
import { SeoService } from './seo/seo-service.service';
import { PodcastContentClientServicesService } from './podcast-content-client-api';
import { BlogDataRestService } from './blog/blog-data-rest.service';
import { AuthorControllerService, PostContentControllerService, PostControllerService, PostGroupControllerService } from './blog-client-api';


// export function ApiConfig() {
//   return new Configuration({
//     basePath: 'http://176.53.45.228:8188',
//     //basePath: 'http://localhost:8080',
//     // accessToken: null,
//     // apiKeys: null,
//     // username: '',
//     // password: '',
//     withCredentials: true
//   });
// };


@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    // ApiModule.forRoot(ApiConfig)
  ],
  declarations: [],
  providers: [
    NewsDataService,
    StaticDataService,
    MenuDataService,
    AuthenticationService,
    CustomerServicesService,
    SubscriberServicesService,
    BtvClientServicesService,
    VodClientServicesService,
    ClientServicesService,
    OperationalService,
    ProductServicesService,
    VodDataRestService,
    BtvDataRestService,
    SubscriptionDataService,
    NotificationCustomerServicesService,
    NotificationMessageServicesService,
    NotDataRestService,
    MetaService,
    PodcastClientServicesService,
    PodcastDataRestService,
    SeoService,
    PodcastContentClientServicesService,
    BlogDataRestService,
    AuthorControllerService,
    PostContentControllerService,
    PostControllerService,
    PostGroupControllerService
    // {provide: VodDataService, useClass: VodDataMockService}, // Use for testing
    // {provide: VodDataService, useClass: VodDataRestService},
    // {provide: BtvDataService, useClass: BtvDataRestService},
    // {provide: SubscriptionDataService, useClass: SubscriptionDataService}
  ]
})
export class DataModule {
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/data/data.module.ts